import React, { useEffect } from 'react';
import AllocationLocationSelector from './allocation/AllocationLocationSelector';

const TokenLocationManageModal = ({
  isOpen,
  onClose,
  locations = [],
  selectedLocationId = '',
  onSelect,
  onCreate,
  onRename,
  onDelete,
  tokenTicker = '',
  tokenLocationBalances = [],
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-gray-600 bg-opacity-50 px-3 py-6">
      <div
        className="max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-lg bg-white p-5 shadow-xl dark:bg-gray-800"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="mb-4 flex items-start justify-between gap-3">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Manage locations</h3>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Create, rename, select, or delete portfolio locations. Delete is only allowed when no transactions or balances use the location.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-gray-500 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white"
            aria-label="Close manage locations"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <AllocationLocationSelector
          locations={locations}
          selectedLocationId={selectedLocationId}
          onSelect={onSelect}
          onCreate={onCreate}
          onRename={onRename}
          onDelete={onDelete}
          autoFocus
          tokenTicker={tokenTicker}
          tokenLocationBalances={tokenLocationBalances}
          inputLabel="Location"
          currentSelectionLabel="Selected location"
          emptySelectionLabel="No location selected"
          placeholder="Type to filter or create a location..."
        />

        <div className="mt-5 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenLocationManageModal;
